import { AgGridReact } from "ag-grid-react";
import {
  defaultColDef,
  getRowId,
  schoolColumns,
  themeColumns,
} from "../../utils/gridHelper";
import { useCallback, useEffect, useMemo, useState } from "react";

import { useStore } from "../../hooks/store";

import ThemeForm from "../Form/ThemeForm/ThemeForm";
import GridToolBar from "../GridToolBar";
import {
  getSchool,
  getSchoolCredits,
  getSchoolGroup,
} from "../../utils/API/schoolMethods";
import { useNavigate } from "react-router";
import NewSchoolForm from "../Form/SchoolForm/NewSchoolForm";
import { getUserBySchool } from "../../utils/API/userMethods";
import { usePortal } from "../../hooks/usePortal";

export function SchoolGrid() {
  const store = useStore();
  const [gridData, setGridData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [quickFilterText, setQuickFilterText] = useState("");
  const [schoolData, setThemeData] = useState(undefined);
  const loading = usePortal();
  const nav = useNavigate();

  //Пока одна автошкола редиректим сразу на пятнашку

  useEffect(() => {
    loading.setPortal();

    Promise.all([getSchool(), getSchoolCredits(1)])
      .then((res) => {
        const [school, schoolCredit] = res;
        const schoolData = school.data.find((s) => Number(s.id) === 1);

        nav(schoolData.id, {
          state: {
            ...schoolData,
            credits: schoolCredit.data || null,
          },
        });

        loading.closePortal();
      })
      .catch();
  }, []);

  const fetchSchoolData = () => {
    getSchool().then(({ data }) => {
      setGridData(data);
    });
  };

  const handleAddOpener = () => {
    store.setForm(<NewSchoolForm />, fetchSchoolData);
  };

  const handleRedactOpener = async () => {
    const schoolCredits = await getSchoolCredits(schoolData.id);
    nav(schoolData.id, {
      state: {
        ...schoolData,
        credits: schoolCredits.data || null,
      },
    });

    // store.setForm(<ThemeForm />, fetchThemeData, schoolData);
  };

  //   const handleDelete = async () => {
  //     // const { id } = schoolData;
  //     // const deletedTheme = await deleteTheme(id);
  //     // if (deletedTheme.status !== 200) {
  //     //   store.setAlert(deletedTheme.data, "error");
  //     //   return;
  //     // }
  //     // fetchThemeData();
  //   };

  const onGridReady = useCallback((e) => {
    // сохраняем АПИ
    setGridApi(e.api);
    fetchSchoolData();
  }, []);

  //Отслеживаем изменение текста для фильтра, устанавливаем соответстствующий фильтр в грид
  useEffect(() => {
    gridApi?.setGridOption("quickFilterText", quickFilterText);
  }, [quickFilterText, gridApi]);

  //выбор конрентной строки
  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: true,
      enableClickSelection: true,
    };
  }, []);

  const rowClickHandler = (e) => {
    console.log(e);
    e.data && setThemeData(e.data);
  };

  return (
    <div style={{ maxWidth: "100%", height: "100%" }}>
      <GridToolBar
        filter={true}
        onAdd={handleAddOpener}
        onRefresh={fetchSchoolData}
        onUpdate={handleRedactOpener}
        filterValue={quickFilterText}
        filterOnChange={setQuickFilterText}
        dataToAction={schoolData}
      />
      <AgGridReact
        onGridReady={onGridReady}
        onRowClicked={rowClickHandler}
        gerRowId={getRowId}
        rowData={gridData}
        defaultColDef={defaultColDef}
        tooltipShowDelay={500}
        rowSelection={rowSelection}
        columnDefs={[...schoolColumns]}
      />
    </div>
  );
}
